import React from 'react';
import Loadable from 'react-loadable';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';

import App from './App';
import Planning from './Planning';
import PlanningOverview from './PlanningOverview';
import NoMatch from './NoMatch';

const loading = () => <h1 className="loading">Lade Komponente</h1>;
const Cases = Loadable({ loader: () => import('./Cases'), loading });
const Labs = Loadable({ loader: () => import('./Labs'), loading });
const QmLabs = Loadable({ loader: () => import('./QmLabs'), loading });
const Reviews = Loadable({ loader: () => import('./Reviews'), loading });
const Analysis = Loadable({ loader: () => import('./Analysis'), loading });
const QsRoundCreation = Loadable({ loader: () => import('./QsRoundCreation'), loading });
const PrintReviews = Loadable({ loader: () => import('./PrintReviews'), loading });
const Assignments = Loadable({ loader: () => import('./Assignments'), loading });
const Users = Loadable({ loader: () => import('./Users'), loading });
const Token = Loadable({ loader: () => import('./Token'), loading });

export default function () {
   return (
      <Router history={hashHistory}>
         <Route path="/print" component={PrintReviews}>
            <Route path=":revID" component={PrintReviews} />
         </Route>

         <Route path="/token/:token" component={Token} />

         <Route path="/" component={App}>
            <Route path="cases" component={Cases}>
               <Route path=":caseID" component={Cases} />
            </Route>
            <Route path="labs" component={Labs}>
               <Route path=":labID" component={Labs} />
            </Route>
            <Route path="planning" component={Planning}>
               <IndexRoute component={PlanningOverview} />
               <Route path="creation" component={QsRoundCreation} />
               <Route path="assignment" component={Assignments} />
               <Route path="reviews" component={Reviews}>
                  <Route path=":revID" component={Reviews} />
               </Route>
               <Route path="labs" component={QmLabs}>
                  <Route path=":labID" component={QmLabs} />
               </Route>
               <Route path="users" component={Users} />
               <Route path="analysis" component={Analysis} />
            </Route>
            <Route path="*" component={NoMatch} />
         </Route>
      </Router>
   );
}
